module.exports = __webpack_public_path__ + "img/pattern_card.1c07e907.jpg";